import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DemandeEncadrementService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getListById(idIntervenant: string | number) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-intervenant-demande-encadrement/list`,
      { params }
    );
  }

  getByDate(idIntervenant: string | number, date) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    params = params.set('date', date.toString());
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-intervenant-demande-encadrement/date`,
      { params }
    );
  }

  getDetailById(idIntervenant: string | number, idSession: string | number) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    params = params.set('idSession', idSession.toString());
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-intervenant-demande-encadrement/detail`,
      { params }
    );
  }
}
